import React from "react";

export default function DistributorContent() {
  return (
    <div>
      <p>
        We are excited to offer you the opportunity to join our growing network
        of dealers, distributors, and super stockists. Partnering with us opens
        doors to lucrative business opportunities and gives you the chance to
        work with a trusted name in the beverages industry. As a well-known
        beverages distributor in Tamil Nadu, we understand what today's market
        needs and how to help our partners grow. We offer drinks that people
        love and ask for again and again. From tasty milkshakes to fruity
        beverages, our brand is trusted for its good taste, clean preparation,
        and fair price. When you join us as a distributor, you get the support
        of a strong supply system, regular stock availability, and a team that
        is always ready to help your business grow. It does not matter if you
        are new to distribution or already have experience. We will guide you at
        every step. We share useful tools and advice to help you succeed with
        ease. If you want to grow with a trusted beverage company, we welcome
        you to partner with us and begin a successful journey with Ruby Food.
      </p>
      <p>
        To apply for dealership, distributorship, or super stockist
        opportunities, please fill out the contact form below or contact our
        partnership team directly at
        <a className="text-theme-light" href="mailto:customerservice@rubyfood.com">
          {" "}
          customerservice@rubyfood.com
        </a>{" "}
        /<a className="text-theme-light" href="tel:+919361804366">+91 93618 04366</a>
      </p>
      <h4 className="main-heading">Why Partner with us?</h4>
      <p>
        We have been in the beverage business for many years and are known for
        our strong customer demand and trusted name. Our products are loved for
        their quality, taste, and freshness. We offer full support, steady
        supply, and affordable pricing to help your business grow. Partnering
        with us means choosing a reliable and successful brand.
      </p>
      <ul>
        <li>* No Deposit Required</li>
        <li>* Dedicated Sales Team Support</li>
        <li>* Dedicated company Customer support</li>
        <li>* High Profit Margins</li>
        <p>FMCG distributors are most preferable</p>
      </ul>
    </div>
  );
}
